import { render } from "./UrlList.vue?vue&type=template&id=2acafaa6&ts=true"
import script from "./UrlList.vue?vue&type=script&lang=ts"
export * from "./UrlList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__